export default __webpack_public_path__ + "static/media/icon-control-24px.d8e2b8f8.svg";